export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000,
} as const;

// Rounds the max listing price up to a human-friendly ceiling
export const computeDynamicPriceMax = (prices: ReadonlyArray<number>): number => {
  if (!prices.length) return PRICE_RANGE.MAX;
  // Avoid Math.max(...prices) — spread into function args can exceed the call stack for large arrays
  const maxPrice = prices.reduce((max, p) => (p > max ? p : max), -Infinity);
  if (maxPrice <= PRICE_RANGE.MAX) return PRICE_RANGE.MAX;
  if (maxPrice <= 5000) return Math.ceil(maxPrice / 500) * 500;
  return Math.ceil(maxPrice / 5000) * 5000;
};

const formatterCache = new Map<string, Intl.NumberFormat>();

const getFormatter = (locale: string, currencyCode: string): Intl.NumberFormat => {
  const key = `${locale}:${currencyCode}`;
  let formatter = formatterCache.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode, maximumFractionDigits: 0, minimumFractionDigits: 0 });
    formatterCache.set(key, formatter);
  }
  return formatter;
};

export const getCurrencySymbol = (currencyCode: string, locale: string): string =>
  getFormatter(locale, currencyCode)
    .formatToParts(0)
    .find(p => p.type === 'currency')?.value ?? currencyCode;

export const formatPriceWithCurrency = (price: number, currencyCode: string, locale: string): string => getFormatter(locale, currencyCode).format(price);

export const WALKING_TIME_THRESHOLD_MINUTES = 15;

// Non-display sentinel for hotels with no chain; translated to "Independent" in BrandFacet
export const INDEPENDENT_BRAND = '__independent__' as const;
